/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentForListing
 */
export interface DocumentForListing {
    /**
     * 
     * @type {string}
     * @memberof DocumentForListing
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentForListing
     */
    fileName: string;
    /**
     * 
     * @type {Date}
     * @memberof DocumentForListing
     */
    updatedDate: Date;
    /**
     * 
     * @type {string}
     * @memberof DocumentForListing
     */
    file: string;
}

/**
 * Check if a given object implements the DocumentForListing interface.
 */
export function instanceOfDocumentForListing(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "updatedDate" in value;
    isInstance = isInstance && "file" in value;

    return isInstance;
}

export function DocumentForListingFromJSON(json: any): DocumentForListing {
    return DocumentForListingFromJSONTyped(json, false);
}

export function DocumentForListingFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentForListing {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fileName': json['fileName'],
        'updatedDate': (new Date(json['updatedDate'])),
        'file': json['file'],
    };
}

export function DocumentForListingToJSON(value?: DocumentForListing | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'fileName': value.fileName,
        'updatedDate': (value.updatedDate.toISOString()),
        'file': value.file,
    };
}

